import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FORM_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import {
    FORM_TYPE_CHECKBOX,
    FORM_TYPE_DATE,
    FORM_TYPE_DATETIME,
    FORM_TYPE_EMAIL, FORM_TYPE_FILE,
    FORM_TYPE_INT, FORM_TYPE_INT_POSITIVE, FORM_TYPE_MULTISELECT,
    FORM_TYPE_PASSWORD, FORM_TYPE_PHONE,
    FORM_TYPE_SELECT,
    FORM_TYPE_SELECT_2,
    FORM_TYPE_TEXT,
    FORM_TYPE_TEXTAREA,
    FORM_TYPE_TIME,
    FORM_WIDTH_COL_10,
    FORM_WIDTH_COL_12,
    FORM_WIDTH_COL_2,
    FORM_WIDTH_COL_3,
    FORM_WIDTH_COL_4,
    FORM_WIDTH_COL_6,
    FORM_WIDTH_COL_8,
    FORM_WIDTH_COL_9,
    FORM_WIDTH_OFFSET_COL_10,
    FORM_WIDTH_OFFSET_COL_2,
    FORM_WIDTH_OFFSET_COL_3,
    FORM_WIDTH_OFFSET_COL_4,
    FORM_WIDTH_OFFSET_COL_6,
    FORM_WIDTH_OFFSET_COL_8,
    INPUT_TIME_STEP
} from "../../../crossconcern/utilities/properties/base.property";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { FormInfo } from "../../../crossconcern/models/form/forminfo";
import { FormInfoField } from "../../../crossconcern/models/form/forminfofield";

@Component({
    selector: FORM_SELECTOR,
    templateUrl: "./form.component.html"
})
export class FormComponent implements OnInit {

    @Input() public formInfo: FormInfo;
    @Output() public filesSelected: EventEmitter<unknown[]> = new EventEmitter<unknown[]>();
    private selectedFiles: unknown[] = [];

    public formTypeText = FORM_TYPE_TEXT;
    public formTypeInt = FORM_TYPE_INT;
    public formTypeCheckbox = FORM_TYPE_CHECKBOX;
    public formTypeIntPositive = FORM_TYPE_INT_POSITIVE;
    public formTypeDate = FORM_TYPE_DATE;
    public formTypeTime = FORM_TYPE_TIME;
    public formTypeDatetime = FORM_TYPE_DATETIME;
    public formTypeSelect = FORM_TYPE_SELECT;
    public formTypeSelect2 = FORM_TYPE_SELECT_2;
    public formTypeEmail = FORM_TYPE_EMAIL;
    public formTypePassword = FORM_TYPE_PASSWORD;
    public formTypeTextarea = FORM_TYPE_TEXTAREA;
    public formTypePhone = FORM_TYPE_PHONE;
    public formTypeFile = FORM_TYPE_FILE;
    public formTypeMultiSelect = FORM_TYPE_MULTISELECT;

    public formWidthCol2 = FORM_WIDTH_COL_2;
    public formWidthCol3 = FORM_WIDTH_COL_3;
    public formWidthCol4 = FORM_WIDTH_COL_4;
    public formWidthCol6 = FORM_WIDTH_COL_6;
    public formWidthCol8 = FORM_WIDTH_COL_8;
    public formWidthCol9 = FORM_WIDTH_COL_9;
    public formWidthCol10 = FORM_WIDTH_COL_10;
    public formWidthCol12 = FORM_WIDTH_COL_12;

    public formWidthOffsetCol2 = FORM_WIDTH_OFFSET_COL_2;
    public formWidthOffsetCol3 = FORM_WIDTH_OFFSET_COL_3;
    public formWidthOffsetCol4 = FORM_WIDTH_OFFSET_COL_4;
    public formWidthOffsetCol6 = FORM_WIDTH_OFFSET_COL_6;
    public formWidthOffsetCol8 = FORM_WIDTH_OFFSET_COL_8;
    public formWidthOffsetCol10 = FORM_WIDTH_OFFSET_COL_10;

    public inputTimeStep = INPUT_TIME_STEP;

    public form: FormGroup;

    constructor(private formBuilder: FormBuilder) {}

    public ngOnInit() {
        const config = {};
        for (const field of this.formInfo.fields) {
            // add the validators
            config[field.formControlName] = [
                null,
                (field.validators)
            ];
        }
        this.form = this.formBuilder.group(config);
    }

    public updateFormValues(formInfo: FormInfo) {
        this.formInfo = formInfo;
        const values = {};
        for (const field of formInfo.fields) {
            values[field.formControlName] = (field.selectedValue !== null) ? field.selectedValue : "";
        }
        logData("FormInfo", this.formInfo);
        this.form.setValue(values);
        logData("Form", this.form);
    }

    public checkMandatory(field: FormInfoField) {
        return field.validators.includes(Validators.required);
    }

    public onChange(field: FormInfoField) {
        if (field.callback) {
            field.callback(this.form.value[field.formControlName]);
        }
    }

    public fileChange(event, formControlName: string) {
        this.selectedFiles[formControlName] = event.target.files;
        this.filesSelected.emit(this.selectedFiles);
    }
}
